import React, {Component} from 'react'
import {Button, Form, InputGroup} from 'react-bootstrap'

export default class Input extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isPasswordShown: false,
        }
    }

    onValueChange = event => {
        this.props.onChange(this.props.field, event)
    }

    togglePasswordVisibility = () => {
        let {isPasswordShown} = this.state
        this.setState({isPasswordShown: !isPasswordShown})
    }

    onClear = () => {
        this.props.onClear()
    }

    renderShowPassword = () => {
        return (
            <div className="right-icon-container">
                <Button
                    className="btn btn-outline-default icon-btn btn-right-icon "
                    variant="outline-secondary"
                    onClick={this.togglePasswordVisibility}
                >
                    <i
                        className={
                            `fas ` +
                            `${this.state.isPasswordShown ? 'fa-eye' : 'fa-eye-slash'}`
                        }
                    ></i>
                </Button>
            </div>
        )
    }

    renderClearButton = () => {
        return this.props.value && (
            <div className="right-icon-container">
                <Button
                    className="btn btn-outline-default icon-btn btn-right-icon"
                    variant="outline-secondary"
                    onClick={this.onClear}
                >
                    <span style={{fontSize: '1.25rem'}} className="ion ion-ios-close"></span>
                </Button>
            </div>
        )
    }

    render() {
        const {type, append} = this.props
        let {isPasswordShown} = this.state

        return (
            <InputGroup className="mb-3">
                <Form.Control
                    {...this.props}
                    type={
                        type === 'password'
                            ? isPasswordShown
                                ? 'text'
                                : 'password'
                            : 'text'
                    }
                    value={this.props.value}
                    onChange={e => this.onValueChange(e)}
                    className="custom-input"
                />
                {type === 'password' && this.renderShowPassword()}
                {type === 'clear' && this.renderClearButton()}
                {append &&
                    <InputGroup.Append>
                        <InputGroup.Text id="basic-addon2">{append}</InputGroup.Text>
                    </InputGroup.Append>
                }
            </InputGroup>
        )
    }
}
